module.exports = __webpack_public_path__ + "static/media/two-left-arrows.57421737.svg";